import { useMemo } from 'react'
import { GamesRoom } from '@/features/games'
import { useOfficeLive } from './OfficeLive'

/**
 * Mounts the games room once for the whole app, with the people it needs to put names to seats. Not
 * mounted while viewing as someone else: a table shows its viewer's own secrets.
 */
export function GamesHost() {
  const live = useOfficeLive()
  const people = live.data?.people
  const list = useMemo(() => (people ?? []).map((p) => ({ userId: p.userId, displayName: p.displayName, photoUrl: p.photoUrl })), [people])
  if (!live.writes || !live.data) return null
  return <GamesRoom me={live.data.me} people={list} />
}
